









import { ModalHelpers } from '@/mixins';
import { ColourVariantType, ModalConstants } from '@/types';
import Vue, { PropType } from 'vue';
import BackgroundDelete from './BackgroundDelete.vue';
import { SearchResultsDocumentModel } from '@/services/GeneratedApi';

export default Vue.extend({
  props: {
    selectedDocuments: {
      required: true,
      type: Array as PropType<SearchResultsDocumentModel[]>
    }
  },
  data() {
    return {
      isDeletingDocuments: false
    };
  },
  computed: {
    isDisabled(this: any) {
      return !this.selectedDocuments?.length;
    }
  },
  methods: {
    async deleteDocuments(this: any) {
      if (
        await ModalHelpers.methods.showConfirmationModalAsync(
          this.$bvModal,
          `Are you sure you want to delete ${this.selectedDocuments.length} document${this.selectedDocuments.length > 1 ? 's' : ''}?`,
          {
            okVariant: ColourVariantType.Danger,
            cancelVariant: ColourVariantType.Primary,
            okTitle: ModalConstants.deleteConfirmationText
          }
        )
      ) {
        this.isDeletingDocuments = true;
      }
    },
    onBackgroundDeleteCompleted(this: any) {
      this.isDeletingDocuments = false;
      this.$emit('background-delete-completed');
    }
  },
  components: {
    BackgroundDelete
  }
});
